import Swal from 'sweetalert2';
import store from '@/store';
import { logEvent } from '@/helpers/cieloLogger';
import CardBrands from '@/models/CardBrands';
import vars from '@/config/vars';

/**
 * Decorator que recebe um processador e adiciona comportamento de autenticação com o MPI
 */
export default class ProcessorWithMpiAuthentication {
    constructor(innerProcessor, multiLanguage) {
        this.InnerProcessor = innerProcessor;
        this.multiLanguage = multiLanguage;
    }

    /**
     * Processa a transação autenticada
     */
    async ProcessTransaction() {
        const cardBrand = store.getters['payment/getSelectedCardBrand'];
        const cardBin = store.getters['cardPayment/getCardBin'];

        const isEloVoucher =
            cardBrand === CardBrands.ELO &&
            vars.ELO_VOUCHER_BIN_LIST.includes(cardBin);

        // Inicia o processo de autenticação da transação
        try {
            let automaticCancellationWhenUnauthenticated = store.getters['mpi/GetAutomaticCancellationWhenUnauthenticated'];

            if (!isEloVoucher || automaticCancellationWhenUnauthenticated == true)
                await store.dispatch('mpi/authenticate');

            await this.InnerProcessor.ProcessTransaction();
        } catch (error) {
            let messageText = error || this.multiLanguage.get('unknownPaymentError');

            Swal.fire({
                type: 'error',
                title: this.multiLanguage.get('finalizingPaymentError'),
                text: messageText
            });

            logEvent({
                category: 'MPI',
                action: 'AUTHENTICATE',
                label: `[AUTHENTICATION PROCESSOR DECORATOR][MPI REJECT RESPONSE] | ${messageText}`
            });
        }
    }
}
